import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sorting_vertical",
  "use": "sorting_vertical-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"sorting_vertical\"><path d=\"M16.736 0H2.908C1.822 0 .933.9.933 2v14c0 1.1.889 2 1.975 2h13.828c1.086 0 1.975-.9 1.975-2V2c0-1.1-.889-2-1.975-2zM6.859 14H4.883V7H6.86v7zm3.95 0H8.835V4h1.976v10zm3.951 0h-1.975v-4h1.975v4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol